import { message } from 'ui/message';

export type Network = 'email' | 'facebook' | 'linkedin';

type NetworkOptions = {
  alert?: () => void;
  domain?: 'facebook.com' | 'linkedin.com' | 'twitter.com';
  generateLink: (params: { emailOnlyText?: boolean; sharedContent: string; subject?: string; text: string }) => string;
};

// eslint-disable-next-line @typescript-eslint/naming-convention -- key is consider as constant
export const NETWORKS: Record<Network, NetworkOptions> = {
  email: {
    alert() {
      message.info('shareEmailInfoMessage');
    },
    generateLink({
      emailOnlyText,
      sharedContent,
      subject,
      text,
    }: {
      emailOnlyText?: boolean;
      sharedContent: string;
      subject?: string;
      text: string;
    }) {
      const mailSubject = subject ?? `Share from ${import.meta.env.VITE_APP_TITLE ?? ''}`;
      const body = emailOnlyText ? text : `${text} ${sharedContent}`;
      return `mailto:?subject=${window.encodeURIComponent(mailSubject)}&body=${window.encodeURIComponent(body)}`;
    },
  },
  facebook: {
    domain: 'facebook.com',
    generateLink({ sharedContent }: { sharedContent: string }) {
      return `https://www.facebook.com/sharer/sharer.php?u=${window.encodeURIComponent(sharedContent)}&src=sdkpreparse`;
    },
  },
  linkedin: {
    domain: 'linkedin.com',
    generateLink({ sharedContent }: { sharedContent: string }) {
      return `https://www.linkedin.com/sharing/share-offsite/?url=${window.encodeURIComponent(sharedContent)}`;
    },
  },
};

function openPopup(url: string, name: string) {
  const width = 640;
  const height = 480;
  const left = window.screen.width / 2 - width / 2;
  const top = window.screen.height / 2 - height / 2;

  return window.open(
    url,
    name,
    `toolbar=no, location=no, directories=no, status=no, menubar=no, scrollbars=no, resizable=no, copyhistory=no, width=${width}, height=${height}, top=${top}, left=${left}`,
  );
}

export const openShareNetworkPopup = ({
  emailOnlyText,
  network,
  sharedContent,
  subject,
  text,
}: {
  emailOnlyText?: boolean;
  network: Network;
  sharedContent: string;
  subject?: string;
  text?: string;
}) => {
  const socialNetwork = NETWORKS[network];

  const redirectUrl = socialNetwork.generateLink({
    emailOnlyText,
    sharedContent,
    subject,
    text: text ?? '',
  });

  if (socialNetwork.alert) {
    setTimeout(() => {
      socialNetwork.alert?.();
    }, 500);
  }

  if (socialNetwork.domain) {
    openPopup(redirectUrl, socialNetwork.domain);
  } else {
    window.location.href = redirectUrl;
  }
};
